import PropTypes from "prop-types";
import React from "react";

import { ReactComponent as MenuSvg } from "assets/icons/menu.svg";
import { MenuIcon, Wrapper } from "./styles";

const Hamburger = ({ isOpened, onClick }) => {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <Wrapper isOpened={isOpened} onMouseDown={handleClick}>
      <MenuIcon>
        <MenuSvg />
      </MenuIcon>
    </Wrapper>
  );
};

Hamburger.propTypes = {
  isOpened: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Hamburger;
